import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Passenger',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Passenger',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Passenger',
    column_type: 'datetime',
  },
  email: {
    model_name: 'Passenger',
    column_type: 'string',
  },
  first_name: {
    model_name: 'Passenger',
    column_type: 'string',
  },
  last_name: {
    model_name: 'Passenger',
    column_type: 'string',
  },
  phone_country_code: {
    model_name: 'Passenger',
    column_type: 'string',
  },
  phone: {
    model_name: 'Passenger',
    column_type: 'string',
  },
  passenger_type: {
    model_name: 'Passenger',
    column_type: 'enum',
  },
  user: {
    model_name: 'Passenger',
    column_type: 'belongs_to',
    extra: {
      association_name: 'user',
      model_name: 'User',
    },
  },
  user_id: {
    model_name: 'Passenger',
    column_type: 'belongs_to',
    extra: {
      association_name: 'user',
      model_name: 'User',
    },
  },
  birthday: {
    model_name: 'Passenger',
    column_type: 'date',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
